 import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";
import _  from 'underscore';
import Test from "./test.js"
import "survey-react/survey.css";
 import "./testing.css"

class Testing extends Component {
  constructor(props){
    super(props)
    this.state = {
      noerorrpage :  true,
      inputtext : false,
      inputboolean : false,
      complete: false,
      saving: false,
      type: 'text',
      textrequired : true,
      inputemail : false,
      inputetextarea : false,
      page : []
     };
     this.props.noerorrpage(this.state.noerorrpage)

    
    }
  json = {
    elements: [
     { type: "text", name: "judge ", title: "What is your name?", isRequired: true},
     
    ]
  
      // pages: [
      //  {
      //   // name: "page1",
      //   elements: [
      //    {
      //     type: "comment",
      //     name: "question1"
      //    },
      //    {
      //     type: "comment",
      //     name: "question2"
      //    },
      //    {type: "comment", name: "judge", title: "enter name"},
      //    {
      //     type: "dropdown",
      //     name: "question3",
      //     choices: [
      //      "item1"
      //     ]
      //    }
      //   ]
      //  }
      // ]
     
   };

   componentDidMount(){
    // console.log("page data----->", this.json.pages[0].elements)
  
    this.setState({
      page:this.json.elements,
      loading:true
    })
    // console.log("page state=====--->",this.state.page, this.json.elements)
   }

  

    onComplete(survey, options) {
      //Write survey results into database
      // console.log("Survey results: " + JSON.stringify(survey.data));
     }

     inputText=(e)=>{
       e.preventDefault();
      //  console.log("event====>",e)
       this.setState({
          inputtext:true
       })
      }
      closeAll=(e)=>{
        e.preventDefault();
        // console.log("event====>",e)
        this.setState({
           inputtext:false,
           inputboolean :false,
           inputemail : false,
           inputetextarea :false

        })
      }
      textrequired=()=>{
        this.setState({
          textrequired: !this.state.textrequired,
          });
          // console.log("check Trucking", this.state.textrequired)
      }
      inputBoolean =(e)=>{
        e.preventDefault();
        this.setState({
          inputboolean :true
        })
      }
      inputeTextarea =(e)=>{
        e.preventDefault();
        this.setState({
          inputetextarea :true
        })
        // console.log("check text", this.state.inputetextarea) 
      }
      inputEmai = (e) =>{
        e.preventDefault();
        this.setState({
          inputemail:true
        })
        // console.log("check email", this.state.inputemail) 
      }

      handleChange=(event)=> {
        this.setState({type: event.target.value});
        // console.log("loggggg------>", this.state.type)
      }
    
     addTextinput=(e)=>{
      e.preventDefault();
      console.log("event====>",this.name.value, this.title.value)
       const   data = {
            type: "text",
            name:this.name.value,
            title :this.title.value,
            placeholder : this.placeholder.value,
            inputType : this.state.type,
            required : this.state.textrequired ,
            isRequired : this.state.textrequired ,
          }

          // const page  = this.json.pages[0].elements
          const   page = this.state.page
            // console.log("page data----->", page )
            // page.push(data)
         //  const payees  = this.state.payees
               
          page.push(data)
       this.setState({
                   page
                })
        // console.log("page data----->", page )
     } 

     addboolean = (e)=>{
      e.preventDefault();
      // console.log("event====>",this.name.value, this.title.value)
      const   data = {
           type: "boolean",
           name:this.name.value,
           title :this.title.value,
           required : this.state.textrequired ,
           isRequired : this.state.textrequired ,
         }
         const   page = this.state.page
          //  console.log("page data----->", page )
         page.push(data)
      this.setState({
                  page
               })
      //  console.log("page data----->", page )
     }
     addEmail = (e)=>{
      e.preventDefault();
      // console.log("event====>",this.name.value, this.title.value)
       const   data = {
            type: "email",
            name:this.name.value,
            title :this.title.value,
            placeholder : this.placeholder.value,
            // inputType : this.state.type,
            required : this.state.textrequired ,
            isRequired : this.state.textrequired ,
            validators: [
              {
               type: "email"
              }
             ],
          }
          const   page = this.state.page
            console.log("page data----->", page )
          page.push(data)
       this.setState({
                   page
                })
        // console.log("page data----->", page )
     }

     addtextarea= (e)=>{
      e.preventDefault();
      // console.log("event====>",this.name.value, this.title.value)
       const   data = {
            type: "comment",
            name:this.name.value,
            title :this.title.value,
            placeholder : this.placeholder.value,
            isRequired : this.state.textrequired ,
            // inputType : this.state.type,
            required : this.state.textrequired ,
          }
          const   page = this.state.page
            // console.log("page data-----> comment page ", page )
          page.push(data)
       this.setState({
                   page
                })
        // console.log("page data----->", page )
     }

     


  render() {
  
    // var model = new Survey.Model(this.json);
    // var model = new Survey.Model(this.state.page);
    // console.log("data of state", this.state.page)
    return (
                <div className="Home"> 
                      <div className="page-testing">
                      <div className="columns">
                          <div className="column is-half">
                               { this.state.loading  ?
                                      <div>
                                            {
                                          this.state.page.map(element=>{
                                                      
                                            return(
                                                <Test
                                                    key={element.name}
                                                    data={element}
                                                    
                                                />
                                            )

                                          })  
                                      }
                                      </div>
                                    :
                                            <div>
                                                <div className="level-item">
                                                    <a className="button is-loading is-large is-light">Loading</a>
                                                </div>  
                                                <br/>
                                            </div>
                                        }
                                        
                           </div>
                          <div className="column">
                                <div>
                                {
                                  this.state.inputtext == true ? (
                                  <form onSubmit={this.addTextinput} >
                                        <div className="texting-input-body">
                                          <div className="texting-input-title">
                                                Enter input name  and title
                                            </div>
                                          <div className="field form-body-area">
                                              <div className="control">
                                                  <input className="input" type="text" 
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.name = input} 
                                                  placeholder="Enter input name" required/>
                                              </div>
                                              <br/>
                                              <div className="control">
                                                  <input className="input" type="text"
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.title = input} 
                                                    placeholder="Enter input title" required/>
                                              </div>
                                              <br/>
                                              <div className="control">
                                                  <input className="input" type="text"
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.placeholder = input} 
                                                    placeholder=" Enter PlaceHolder" required/>
                                              </div>
                                              <br/>
                                              
                                                
                                               <label className="checkbox testing-input-required">
                                                  <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                       The you want it to be required
                                                </label>

                                                <div className="select testing-input-magin">
                                                  <select value={this.state.type} onChange={this.handleChange}>
                                                    <option value="tel">tel</option>
                                                    <option value="text">text</option>
                                                    <option value="date">date</option>
                                                    <option value="number">number</option>
                                                  </select>
                                               </div> 
                                                <br/>
                                                <br/>

                                                  {/* <input  className="checkbox"  checked={this.state.textrequired} onChange={this.textrequired} type="checkbox"/> */}
                                            </div>
                                        </div>
                                          <div>
                                            <button className="button is-success is-small is-rounded">Submit</button>  |   
                                            <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                          </div>
                                      </form>  
                                  ) :this.state.inputboolean == true ? (
                                    <div>
                                      <form onSubmit={this.addboolean} >
                                        <div className="texting-input-body">
                                           <div className="texting-input-title">
                                               Enter name of your condition
                                            </div>
                                          <div className="field form-body-area">
                                              <div className="control">
                                                  <input className="input" type="text" 
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.name = input} 
                                                  placeholder="Example the you love music"/>
                                              </div>
                                              <div className="control">
                                                  <input className="input" type="text" 
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.title = input} 
                                                  placeholder="Example the you love music"/>
                                              </div>
                                              <label className="checkbox testing-input-required">
                                                  <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                       The you want it to be required
                                              </label>
                                          </div>
                                        </div>
                                          <div>
                                            <button className="button is-success is-small is-rounded">Submit</button>  |   
                                            <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                          </div>
                                      </form>  
                                    </div>
                                  ):this.state.inputemail == true ? (
                                     <div>   
                                          <form onSubmit={this.addEmail} >
                                            <div className="texting-input-body">
                                              <div className="texting-input-title">
                                                    Enter input Email
                                                </div>
                                              <div className="field form-body-area">
                                                  <div className="control">
                                                      <input className="input" type="text" 
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.name = input} 
                                                      placeholder="Enter input name" required/>
                                                  </div>
                                                  <br/>
                                                  <div className="control">
                                                      <input className="input" type="text"
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.title = input} 
                                                        placeholder="Enter input title" required/>
                                                  </div>
                                                  <br/>
                                                  <div className="control">
                                                      <input className="input" type="text"
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.placeholder = input} 
                                                        placeholder=" Enter PlaceHolder" required/>
                                                  </div>
                                              
                                                  <label className="checkbox testing-input-required">
                                                      <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                          The you want it to be required
                                                    </label>

                                                      
                                                </div>
                                            </div>
                                             <div>
                                              <button className="button is-success is-small is-rounded">Submit</button>  |   
                                              <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                             </div>
                                      </form>   
                                    </div>
                                     ):this.state.inputetextarea == true ? (
                                          <div> 
                                             <form onSubmit={this.addtextarea} >
                                               <div className="texting-input-body">
                                                  <div className="texting-input-title">
                                                     Enter name of Testarea
                                                 </div>
                                              <div className="field form-body-area">
                                                  <div className="control">
                                                      <input className="input" type="text" 
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.name = input} 
                                                      placeholder="Enter input name" required/>
                                                  </div>
                                                  <br/>
                                                  <div className="control">
                                                      <input className="input" type="text"
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.title = input} 
                                                        placeholder="Enter input title" required/>
                                                  </div>
                                                  <br/>
                                                  <div className="control">
                                                      <input className="input" type="text"
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.placeholder = input} 
                                                        placeholder=" Enter PlaceHolder" required/>
                                                  </div>
                                              
                                                  <label className="checkbox testing-input-required">
                                                      <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                          The you want it to be required
                                                    </label>

                                                      
                                                </div>
                                            </div>
                                          <div>
                                             <button className="button is-success is-small is-rounded">Submit</button>  |   
                                              <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                          </div>
                                      </form>   
                                          </div>
                                      )
                                    :

                                      <div className="texting-body-button">
                                          <a className="button is-link is-small is-rounded" onClick={this.inputText}>Text input</a>
                                          <a className="button is-link is-small is-rounded  texting-input-button" onClick={this.inputeTextarea}>Textarea input</a>
                                          <a className="button is-link is-small is-rounded  texting-input-button" onClick={this.inputEmai}>Email input</a>
                                          <a className="button is-link is-small is-rounded texting-input-button" onClick={this.inputBoolean}>Boolean</a>
                                      </div>
                                     
                                 } 
                             </div> 
                          </div>
                         
                        </div>


                          
                      </div>

                </div>
            )
        }
    }    

  export default Testing ;      





// WEBPACK FOOTER //
// ./src/component/testing/testing.js